'use client';
import React, { useEffect } from 'react';

/** Set on `<html>` while a shared filtered link waits for its filters. */
export const SORT_FILTER_PENDING_ATTR = 'data-sort-filter-pending';
/** Marks the results region `cms.css` swaps for skeletons meanwhile. */
export const SORT_FILTER_RESULTS_ATTR = 'data-sort-filter-results';

/** Clears the mark if the page never hydrates, so results cannot stay hidden. */
const FALLBACK_MS = 5000;

export const pendingScript = (params: readonly string[]): string =>
  `(function(){try{var s=new URLSearchParams(location.search),n=${JSON.stringify(
    params,
  ).replace(
    /</g,
    '\\u003c',
  )};for(var i=0;i<n.length;i++)if(s.get(n[i])){var d=document.documentElement;d.setAttribute('${SORT_FILTER_PENDING_ATTR}','');setTimeout(function(){d.removeAttribute('${SORT_FILTER_PENDING_ATTR}')},${FALLBACK_MS});return}}catch(e){}})()`;

/**
 * CMS-1542 R9.6: the server renders the unfiltered list, because reading the
 * query would drop the static cache. A shared filtered link therefore marks
 * the page before first paint, and the mark clears once the filters apply.
 */
export const FilteredLinkGate: React.FC<{
  params: readonly string[];
  applied: boolean;
}> = ({ params, applied }) => {
  useEffect(() => {
    if (applied) {
      document.documentElement.removeAttribute(SORT_FILTER_PENDING_ATTR);
    }
  }, [applied]);

  if (!params.length) return null;
  return (
    // eslint-disable-next-line react/no-danger -- static per page; values are JSON-escaped
    <script dangerouslySetInnerHTML={{ __html: pendingScript(params) }} />
  );
};
